import { Tooltip } from "primereact/tooltip";

import { C, themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { ExternalAccessControl } from "./ExternalAccessControl";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export const ExternalAccessControlCard = () => {
  return (
    <div
      className={C(themeClasses.bgElevation2, "p-6 rounded-md shadow-md")}
      data-testid="external-access-control-card"
    >
      <div
        className={C(
          "flex justify-between items-center border-b-2 pb-3 mb-6",
          themeClasses.borderSurfaceBorder
        )}
      >
        <h3 className="text-xl font-semibold flex-1 mb-0">External Access Control</h3>
      </div>
      <div className="flex flex-col gap-6">
        <ExternalAccessControl />
        <Tooltip target=".pi-info-circle" className="max-w-xs" />
      </div>
    </div>
  );
};
